var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35066465-D465-4ADA-BB72-5F7A3F1B08EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Scheduling-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scheduling---NPS-(virtual)",
    transform: "translate(-244.000000, -1049.000000)",
    fill: "#2E853F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Confirmed",
    transform: "translate(202.000000, 1022.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task_alt_black_24dp",
    transform: "translate(42.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,6.042 L16.321,27.74 L8.265,19.684 L10.944,17.005 L16.321,22.382 L35.321,3.382 L38,6.042 Z M33.801,15.618 C34.048,16.701 34.2,17.841 34.2,19 C34.2,27.398 27.398,34.2 19,34.2 C10.602,34.2 3.8,27.398 3.8,19 C3.8,10.602 10.602,3.8 19,3.8 C22.002,3.8 24.776,4.674 27.132,6.175 L29.868,3.439 C26.79,1.273 23.047,0 19,0 C8.512,0 0,8.512 0,19 C0,29.488 8.512,38 19,38 C29.488,38 38,29.488 38,19 C38,16.739 37.582,14.573 36.86,12.559 L33.801,15.618 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.94ac8103bb51310f6ca7780ea01f4d7d.svg";
export { ForwardRef as ReactComponent };